import { Map, Sprite, Table, TableSaleLocation } from './Map';
import Point from './Point';
import Bounds from './Bounds';
import * as Coordinates from './Coordinates';

export function clearSelectedSprites(allSprites: Sprite[]): void {
	allSprites.forEach(s => s.selected = false);
}

export function selectSingleSprite(point: Point, allSprites: Sprite[], addToSelectedItems: boolean): void {
	if (!addToSelectedItems)
		clearSelectedSprites(allSprites);

	const sprite = getItemAt(point, allSprites);
	if (sprite)
		sprite.selected = true;
}

export function selectMultipleSprites(bounds: Bounds, allSprites: Sprite[], addToSelectedItems: boolean): void {
	if (!addToSelectedItems)
		clearSelectedSprites(allSprites);

	const sprites = getItemsIn(bounds, allSprites);
	if (sprites.length > 0)
		sprites.forEach(s => s.selected = true);
}

export function getItemAt(point: Point, sprites: Sprite[]): Nullable<Sprite> {
	// Devolvemos siempre el último añadido
	const candidates = sprites.filter(sprite => Coordinates.containsPoint(sprite.getBounds(), point));
	return candidates ? candidates[candidates.length - 1] : null;
}

export function getItemsIn(bounds: Bounds, sprites: Sprite[]): Sprite[] {
	return sprites.filter(sprite => Coordinates.containedIn(bounds, sprite.getBounds()));
}

export function getLogicalMousePoint(e: React.MouseEvent<HTMLCanvasElement>, canvas: HTMLCanvasElement, map: Map): Point {
	const scale = Coordinates.getScale(canvas, { width: map.width, height: map.height });
	return Coordinates.getLogicalMousePoint(canvas, e, scale);
}

export function getLogicalTouchPoint(e: React.TouchEvent<HTMLCanvasElement>, canvas: HTMLCanvasElement, map: Map): Point {
	const scale = Coordinates.getScale(canvas, { width: map.width, height: map.height });
	return Coordinates.getLogicalTouchPoint(canvas, e, scale);
}

export function getLocationAt(e: React.MouseEvent<HTMLCanvasElement>, canvas: HTMLCanvasElement, map: Map): Nullable<TableSaleLocation> {
	const point = getLogicalMousePoint(e, canvas, map);
	const tables: Table[] = map.sprites.filter(x => x instanceof Table) as Table[];
	const table = tables.find(x => x.getBounds().contains(point));
	return table ? table.location : null;
}

export function findTableByLocation(map: Map, location: TableSaleLocation): Nullable<Table> {
	const tables: Table[] = map.sprites.filter(x => x instanceof Table) as Table[];
	const table = tables.find(x => x.location.saleCenterId === location.saleCenterId && x.location.saleLocationName === location.saleLocationName);
	return table ?? null;
}